module.exports = __webpack_public_path__ + "media/application/images/2023/Headline LG-d85d1dd53f532ddbe4bfd182dd960305.png";